import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import App from './App'
import './index.css'

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
})

const AppTree = () => (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        basename="/"
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'var(--color-surface-deep)',
              color: 'var(--color-text)',
              fontFamily: 'sofia-pro, sans-serif',
              border: '1px solid var(--color-border)',
            },
            success: {
              style: {
                background: 'var(--color-surface-deep)',
                color: 'var(--color-primary)',
                borderColor: 'var(--color-primary)',
              },
            },
            error: {
              style: {
                background: 'var(--color-surface-deep)',
                color: 'var(--color-danger)',
                borderColor: 'var(--color-danger)',
              },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  recaptchaSiteKey ? (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
      <AppTree />
    </GoogleReCaptchaProvider>
  ) : (
    <AppTree />
  )
)